module.exports = __webpack_public_path__ + "img/32.db9cd8a6.webp";